import Vue from "vue";
import VueRouter from "vue-router";
import SparePartKits from "./vue/sparePartKits.vue";

const appSparePartKits = document.querySelector("#app-spare-part-kits");
if (appSparePartKits) {

    const router = new VueRouter({
        mode: "history"
    });
    Vue.use(VueRouter);
    const rootNodeId = appSparePartKits.dataset.rootNodeId;
    const notice = appSparePartKits.dataset.notice;
    const preselectedSparePartKits = appSparePartKits.dataset.preselectedKits;
    const preselectedPumpSeriesFacet = appSparePartKits.dataset.pumpSeriesFacet;
    const preselectedPumpSizeFacet = appSparePartKits.dataset.pumpSizeFacet;
    const preselectedPumpDesignFacet = appSparePartKits.dataset.pumpDesignFacet;

    var sparePartKitsApp = new Vue({
        el: appSparePartKits,
        data: {
            rootNodeId:rootNodeId,
            notice:notice,
            preselectedSparePartKits: preselectedSparePartKits,
            preselectedPumpSeriesFacet: preselectedPumpSeriesFacet,
            preselectedPumpSizeFacet: preselectedPumpSizeFacet,
            preselectedPumpDesignFacet: preselectedPumpDesignFacet
        },
        render: h => h(SparePartKits),
        router
    });
}